// extracted by mini-css-extract-plugin
export default {"progress":"progress__2OD62","percentage":"percentage__3Ss88","spinner":"spinner__3uVuz","progress-bar":"progress-bar__2TryK"};